import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  redirectToProcessingPreEvaluation,
  redirectToPreEvaluationCompleted,
} from '../../ducks/Navigate';
import {Footer, ScreenNotificationDefault} from '../../components';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';

import './styles.scss';

class ConfirmPhoneSuccess extends Component {
  componentDidMount() {
    document.title = StringService.formatTitle(
      RouteKeys.ConfirmPhoneSuccess.title,
    );
  }

  render() {
    return (
      <div className="div-confirm-phone">
        <ScreenNotificationDefault
          title={
            <div className="header-background">
              <div className="done">
                <div className="icon-check">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 59.76 51.4"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Header">
                        <path
                          className="cls-1"
                          d="M21.51,51.4A4.83,4.83,0,0,1,18.13,50L1.4,33.26A4.78,4.78,0,1,1,8.16,26.5l13,13L51.25,1.79a4.78,4.78,0,0,1,7.46,6L25.24,49.6a4.77,4.77,0,0,1-3.47,1.79Z"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <p id="textoText" className="text">
                  {' '}
                  Pronto{' '}
                </p>
              </div>
            </div>
          }
          contentCustom={
            <div id="textoTitle" className="title">
              <p>Celular confirmado com sucesso.</p>
            </div>
          }
          contentButtons={
            <div className="footer-confirm-phone">
              <Footer
                textNext="Próximo"
                nextHandle={
                  this.props.realizouPreAvaliacao
                    ? this.props.redirectToPreEvaluationCompleted
                    : this.props.redirectToProcessingPreEvaluation
                }
                hideBtnBack={true}
              />
            </div>
          }
        />
      </div>
    );
  }
}

const mapStateToProps = ({customer}) => {
  const {realizouPreAvaliacao} = customer;
  return {realizouPreAvaliacao};
};
export default connect(mapStateToProps, {
  redirectToProcessingPreEvaluation,
  redirectToPreEvaluationCompleted,
})(ConfirmPhoneSuccess);
